import { Box, CardActionArea, Stack, Typography } from '@mui/material';
import { format as formatDate } from 'date-fns';
import { de } from 'date-fns/locale';
import Link from 'next/link';
import PropTypes from 'prop-types';

import RichText from '@/components/RichText/RichText';
import StrapiImage from '@/components/StrapiImage/StrapiImage';
import blogConfig from '@/configs/blog';
import { blogPostPropType } from '@/constants/propTypes';

import {
  CardMedia,
  Chip,
  ExcerptContent,
  Heading,
  TileWrapper,
} from './Tile.style';

const Tile = ({ data, query }) => {
  const { attributes: blogPostAttributes } = data;
  const categoryAttributes = blogPostAttributes.blogCategory.data?.attributes;
  const blogPostPathname = blogPostAttributes.metadata.pathname;
  const categoryPathname = categoryAttributes?.metadata?.pathname;

  return (
    <TileWrapper variant="outlined">
      <CardActionArea
        component={Link}
        href={{
          pathname: `${blogConfig.basePathname}${
            categoryPathname ? categoryPathname : blogConfig.allCategoryPathname
          }${blogPostPathname}`,
          query: {
            prevCategory: query.category,
            ...(query.page ? { prevPage: query.page } : {}),
          },
        }}
        sx={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'stretch',
          justifyContent: 'flex-start',
        }}>
        <CardMedia>
          <Box
            sx={{
              position: 'relative',
              width: '100%',
              height: 200,
            }}>
            <StrapiImage
              data={blogPostAttributes.heroImage.data}
              sizes="(max-width: 600px) 100vw, (max-width: 1200px) 50vw, 400px"
              fill
              style={{ objectFit: 'cover' }}
            />
          </Box>
        </CardMedia>
        <Stack p={2} flex={1}>
          <Typography
            data-test-subject="published-at"
            variant="subtitle2Redesign"
            component="div"
            color="grayscale.500"
            mb="6px">
            {`${blogPostAttributes.author} • ${formatDate(
              new Date(blogPostAttributes.publishedAt),
              'd MMMM yyyy',
              { locale: de }
            )}`}
          </Typography>
          <Heading variant="h6Redesign" component="h3" color="primary.dark">
            {blogPostAttributes.title}
          </Heading>
          <ExcerptContent>
            <RichText data={blogPostAttributes.excerpt} />
          </ExcerptContent>
          {categoryAttributes && (
            <Chip
              size="small"
              data-test-subject="tile-category-label"
              backgroundColor={categoryAttributes.color}
              sx={{ alignSelf: 'flex-start' }}>
              {categoryAttributes.title}
            </Chip>
          )}
        </Stack>
      </CardActionArea>
    </TileWrapper>
  );
};

Tile.propTypes = {
  data: blogPostPropType.isRequired,
  query: PropTypes.shape({
    category: PropTypes.string,
    page: PropTypes.string,
  }),
};

Tile.defaultProps = {
  query: {},
};

export default Tile;
